import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg, ROLE_HOME } from "@/lib/api";

export const startGoogleSignIn = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/login";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

export const GoogleButton = ({ testId = "google-signin-button" }) => (
  <>
    <button
      type="button"
      data-testid={testId}
      onClick={startGoogleSignIn}
      className="flex h-12 w-full items-center justify-center gap-3 rounded-xl border border-slate-200 bg-white font-semibold text-slate-800 transition-colors hover:border-blue-300 hover:bg-blue-50"
    >
      <GoogleIcon /> Continue with Google
    </button>
    <div className="my-6 flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-slate-400">
      <span className="h-px flex-1 bg-slate-200" /> or <span className="h-px flex-1 bg-slate-200" />
    </div>
  </>
);

export const AuthCallback = () => {
  const { hash } = useLocation();
  const nav = useNavigate();
  const { signIn } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    signIn("/auth/google", { session_id: sessionId })
      .then((u) => nav(ROLE_HOME[u.role], { replace: true }))
      .catch((e) => setError(errMsg(e)));
  }, [hash, nav, signIn]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#0B192C] px-6 text-center" data-testid="google-callback">
      {error ? (
        <>
          <p className="text-white" data-testid="google-callback-error">{error}</p>
          <button onClick={() => nav("/login", { replace: true })} className="rounded-full bg-amber-400 px-6 py-2.5 font-bold text-slate-900">Back to sign in</button>
        </>
      ) : (
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-400 border-t-amber-400" />
      )}
    </div>
  );
};
